<ng-container *ngIf="antwoordResultaat">
  <div data-hj-suppress *ngIf="antwoordResultaat.resultaat && isFilesUpload" class="uploadfiles-container">
    <div *ngFor="let file of antwoordResultaat.resultaat.uploadedFiles" class="uploadfile file">
      <div class="thumbnail_filename">
        <div class="thumbnail" [ngClass]="{'doc' : !isFileImage(file.name)}">
          <img *ngIf="!isFileImage(file.name)" src="/assets/icons/ols/document.svg" />
          <img *ngIf="isFileImage(file.name)" [src]="file.dataUrl | sanitizeUrl" />
        </div>
        <div class="filename">{{file.name}}</div>
      </div>
    </div>
  </div>
  <div data-hj-suppress *ngIf="antwoordResultaat.resultaat && !isFilesUpload" class="uploadimages-container">
    <div *ngFor="let file of antwoordResultaat.resultaat.uploadedFiles" class="uploadimage file">
      <img [src]="file.dataUrl | sanitizeUrl" />
    </div>
  </div>
  <div *ngIf="antwoordResultaat.resultaat == null || antwoordResultaat.resultaat.uploadedFiles == null || antwoordResultaat.resultaat.uploadedFiles.length === 0">
    Er zijn geen {{uploadtype}} toegevoegd.
  </div>
</ng-container>